import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { strSortFn, valSortFn, customerShape } from '../helperFunctions';
import CustomerTable from './CustomerTable';
import CustomerContainer from './CustomerContainer';

import List from '../List';

const customersViewFilters = [
  {
    id: 'ACTIVE_CUSTOMERS',
    label: 'Active',
    filterFn: (item) => item.status === 'Active'
  },
  {
    id: 'PENDING_CUSTOMERS',
    label: 'Pending Approval',
    filterFn: (item) => item.status === 'PendingApproval'
  },
  {
    id: 'DECLINED_CUSTOMERS',
    label: 'Declined',
    filterFn: (item) => item.status === 'Declined'
  },
  {
    id: 'ALL_CUSTOMERS',
    label: 'All Customers',
    filterFn: () => true
  }
];

const customersSortFilters = [
  {
    id: 'CUSTOMER_NAME_SORT',
    label: 'Customer Org (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'name')
  },
  {
    id: 'CUSTOMER_NAME_SORT_DESC',
    label: 'Customer Org (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'name', 'desc')
  },
  {
    id: 'CUSTOMER_CONTACT_SORT',
    label: 'Contact Email (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'contactEmail')
  },
  {
    id: 'CUSTOMER_CONTACT_SORT_DESC',
    label: 'Contact Email (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'contactEmail', 'desc')
  },
  {
    id: 'CUSTOMER_BOOKINGS_SORT',
    label: 'Num Bookings (asc)',
    sortFn: (a, b) => valSortFn(a, b, 'bookings')
  },
  {
    id: 'CUSTOMER_BOOKINGS_SORT_DESC',
    label: 'Num Bookings (desc)',
    sortFn: (a, b) => valSortFn(a, b, 'bookings', 'desc')
  }
];

function CustomerList(props) {
  const { allCustomers, loading, error } = props;

  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <CustomerContainer>
          {({
            pagination,
            search,
            sortBy,
            toggle,
            view,
            updatePagination,
            updateSearch,
            updateSortBy,
            updateToggle,
            updateView
          }) => (
            <List
              initialViewFilterId={view}
              initialSortFilterId={sortBy}
              initialQueryValue={search}
              initialToggleValue={toggle}
              initialPaginationValue={pagination}
              data={allCustomers}
              loading={loading}
              error={error}
              viewFilters={customersViewFilters}
              sortFilters={customersSortFilters}
              screenClass={screenClass}
              tableComponent={CustomerTable}
              helpText="Search by customer name or email"
              noDataObj={{
                message: 'There are no customers for that search, or no customers have been created',
                title: 'No Customers'
              }}
              searchBy={['name', 'contactEmail']}
              listComponentProps={{
                interactionHooks: {
                  onPaginationChange: (p) => updatePagination(p),
                  onSearchChange: (s) => updateSearch(s),
                  onSortFilterClick: (s) => updateSortBy(s.id),
                  onViewFilterClick: (v) => updateView(v.id),
                  onViewToggleClick: (t) => updateToggle(t)
                }
              }}
            />
          )}
        </CustomerContainer>
      )}
    />
  );
}

CustomerList.propTypes = {
  allCustomers: PropTypes.arrayOf(customerShape).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.shape({})
};

CustomerList.defaultProps = {
  loading: true,
  error: null
};

export default CustomerList;
